import { css } from "@emotion/react";

export const primary = css`
  background-color: var(--color-text-primary);
`;

export const secondary = css`
  background-color: var(--color-text-secondary);
`;

export const blurred = {
  primary: css`
    background-color: color-mix(
      in srgb,
      var(--color-background-primary),
      transparent 20%
    );
    backdrop-filter: blur(25px) saturate(180%);
  `,
  secondary: css`
    background-color: color-mix(
      in srgb,
      var(--color-background-secondary),
      transparent 20%
    );
    backdrop-filter: blur(25px) saturate(180%);
  `
};
